<template lang="pug">
  div
    flex-body(:rows="doc.acf.body")
    further-reading(:doc="doc.acf")
</template>

<script>
import FlexBody from '@/components/FlexBody/FlexBody'
import FurtherReading from '@/components/FurtherReading'
export default {
  name: 'Overview',
  props: ['doc'],
  components: { FlexBody, FurtherReading }
}

</script>

<style>
</style>
